module.exports = __webpack_public_path__ + "static/media/bonusu_rats_stand_min.16dce7e2.png";